import axios from "axios";
import { refreshToken } from "../helpers/RequestExecutor";

export const getCollectedCards = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/cards/collected`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getCollectedCards();
        } else {
            return e.response.data;
        }
    }
}